import { PropsWithChildren } from "react";
import styled from "styled-components";

const StyledLabel = styled.label`
  color: var(--color-label);
`;

export interface ILabelProps {
  htmlFor: string;
  className?: string;
  required?: boolean;
  optional?: boolean;
}

export function Label({
  htmlFor,
  children,
  className,
  required = false,
  optional = false,
}: PropsWithChildren<ILabelProps>): JSX.Element {
  return (
    <StyledLabel htmlFor={htmlFor} className={className}>
      {children}

      {required && (
        <span aria-hidden="true" style={{ color: "var(--red-600)" }}>
          {" *"}
        </span>
      )}

      {optional && (
        <span style={{ color: "var(--brand-gray-500)", fontWeight: 400 }}>
          {" · optional"}
        </span>
      )}
    </StyledLabel>
  );
}
